export const AUTHENTICATE_LOADING = 'user/AUTHENTICATE_LOADING';
export const AUTHENTICATE_SUCCESS = 'user/AUTHENTICATE_SUCCESS';
export const SESSION_FINISHED = 'user/SESSION_FINISHED';
export const AUTHENTICATE_FAIL = 'user/AUTHENTICATE_FAIL';
export const VERIFY_FAIL = 'user/VERIFY_FAIL';

export const defaultState = {
  user: {
    logged: false,
    message: '',
    isLoading: false
  }
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case AUTHENTICATE_LOADING:
      return {
        ...state,
        user: {
          ...state.user,
          isLoading: action.payload
        }
      };

    case AUTHENTICATE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          logged: true,
          // message: 'User logged correctly.'
        }
      };

    case SESSION_FINISHED:
      return {
        ...state,
        user: {
          ...state.user,
          logged: false,
        }
      };

    case AUTHENTICATE_FAIL:
      return {
        ...state,
        user: {
          ...state.user,
          logged: false,
          message: 'Unathorized user. User doesn\'t exist or emails and password are wrong.'
        }
      };

    case VERIFY_FAIL:
      return {
        ...state,
        user: {
          ...state.user,
          logged: false
        }
      };


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/login-form/reducer.js